<template>
<div class="popup" v-cloak v-show="taskSchduleShow" @click="reSet()">
    <div class="content" id="taskSchdule">
        <div class="title">
            {{$t('language.popup.cloudTransferPopup.schedule')}}
            <div class="icon white-close dialog-close" @click.stop="scheduleClose()"></div>
        </div>
        <div class="task-schdule-body">
            <el-tabs v-model=activeName>
                <el-tab-pane :label="$t('language.popup.daily')" name="first">
                    <tab1 ref="daily" @changeTabDaily='onChangeTabDaily'></tab1>
                </el-tab-pane>
                <el-tab-pane :label="$t('language.popup.weekly')" name="second">
                    <tab2 ref="weekly"></tab2>
                </el-tab-pane>
                <el-tab-pane :label="$t('language.popup.monthly')" name="third">
                    <tab3 ref="monthly"></tab3>
                </el-tab-pane>
            </el-tabs>
            <div class="schedule-footer">
                <button class="schedule-save" @click.stop="saveSchdule()">{{$t('language.common.save')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import tab1 from "@/components/common/tabs/tabs_transfer_schedule/tab_daily";
import tab2 from "@/components/common/tabs/tabs_transfer_schedule/tab_weekly";
import tab3 from "@/components/common/tabs/tabs_transfer_schedule/tab_monthly";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    components: {
        tab1,
        tab2,
        tab3
    },
    data: function () {
        return {
            activeName: "first",
            taskSchduleShow: false,
            indexCurrent: '',
            tabBarClass: '',
            schedules: {
                type: '',
            },
            oldSchedules: {},
            times: [],
            weeks: [],
            days: [],
            date: '',
            oldDailyTimeArr: []
        }
    },
    methods: {
        //重置整个弹框的数据
        reSet() {
            this.$refs.daily.$refs.onceDate.checkYear = false;
            this.$refs.daily.$refs.onceDate.checkMonth = false;
            this.$refs.daily.$refs.onceDate.checkDay = false;
            this.$refs.daily.$refs.onceTime.checkMinute = false;
            this.$refs.daily.$refs.onceTime.checkHour = false;
            this.$refs.daily.$refs.dailyTime0.checkMinute = false;
            this.$refs.daily.$refs.dailyTime0.checkHour = false;
            this.$refs.daily.$refs.dailyTime1.checkMinute = false;
            this.$refs.daily.$refs.dailyTime1.checkHour = false;
            this.$refs.daily.$refs.dailyTime2.checkMinute = false;
            this.$refs.daily.$refs.dailyTime2.checkHour = false;
            this.$refs.weekly.$refs.weekTime.checkMinute = false;
            this.$refs.weekly.$refs.weekTime.checkHour = false;
            this.$refs.monthly.$refs.monthTime.checkMinute = false;
            this.$refs.monthly.$refs.monthTime.checkHour = false;
            window.getSelection().empty();
        },
        onChangeTabDaily(value) {
            this.times = value;
        },
        validatorTime(){
        var timeValue=this.date+' '+this.times[0];
        var myDate = new Date();
        var now = myDate.valueOf();
        var time = new Date(timeValue).valueOf();
        if(now > time){
            return true;
        }else{
        return false;
        }
        },
        saveSchdule() {
            let that = this;
            let type;
            if (this.schedules.type) {
                type = this.schedules.type;
                if (type == 'Once') {
                    this.date = this.$refs.daily.onceDateValue;
                    if (!this.times.length) {
                        this.times.push(that.$refs.daily.onceTime);
                    }
                  if(this.validatorTime()){
                        that.$toast({
                        text: this.$t('language.teamTransfer.timePassed'),
                        type: 'fail',
                        idValue: "taskSchdule"
                   });
                  return false;
                  }

                    // //判断日期是否是今天
                    // if(new Date(this.date).toDateString()==new Date().toDateString()){
                    //    //判断时间
                    //  }
                  
                }
            } else {
                type = "Once";
                this.oldDailyTimeArr = [];
                if (!this.times.length) {
                    this.times.push(that.$refs.daily.onceTime);
                }
                 if(this.validatorTime()){
                        that.$toast({
                        text: this.$t('language.teamTransfer.timePassed'),
                        type: 'fail',
                        idValue: "taskSchdule"
                   });
                  return false;
                  }
              //  console.log(that.$refs.daily.onceTime);
            }
            //当用户未选择时间类型
            if (this.activeName == 'first' && type != 'Daily' && type != 'Once') {
                that.$refs.daily.shakeAll = "first-shake";
                setTimeout(() => {
                    that.$refs.daily.shakeAll = "box-shakeOrigin";
                }, 200);
                return false;
            }
            if (type == 'Daily' && !this.times.length) {
                that.$refs.daily.shakeBox = "email-shake";
                setTimeout(() => {
                    that.$refs.daily.shakeBox = "box-shakeOrigin";
                }, 200);
                return false;
            }
            if (type == 'Daily' && this.times.length) {
                this.oldDailyTimeArr = this.$refs.daily.dailyTimeArr;
            }
            if (this.activeName == 'second' && !this.weeks.length) {
                that.$refs.weekly.shakeBox = "box-shakeY ";
                setTimeout(() => {
                    that.$refs.weekly.shakeBox = "box-shakeYOrigin";
                }, 200);
                return false;
            }
            if (this.activeName == 'third' && !this.$refs.monthly.monthArr.length) {
                that.$refs.monthly.shakeBox = "box-shakeNumber ";
                setTimeout(() => {
                    that.$refs.monthly.shakeBox = "box-shakeYOrigin";
                }, 200);
                return false;
            }
            //可以保存定时计划任务执行时，提示需要付费才能使用
            if (!commonUtils.getUser().vip) {
                this.$parent.$refs.upgradeDialog.upgradeShow = true;
                this.$parent.$refs.upgradeDialog.reset();
                this.$parent.$refs.upgradeDialog.scheduledShow = true;
                return false;
            }
            this.schedules = {};
            this.taskSchduleShow = false;
            this.$parent.checkedSchedule = true;
            if (this.date) {
                this.schedules.date = this.date;
            }
            if (this.days.length) {
                this.oldDailyTimeArr = [];
                this.schedules.days = Object.assign([], this.days);
            }
            if (this.weeks.length) {
                this.oldDailyTimeArr = [];
                this.schedules.weeks = Object.assign([], this.weeks);
            }
            this.schedules.clientTime = commonUtils.getNowDateFormat();
            this.schedules.times = Object.assign([], this.times);
            this.schedules.type = type;
            this.$parent.pSchedules = Object.assign({}, this.schedules);
            this.oldSchedules = Object.assign({}, this.$parent.pSchedules);
        },
        scheduleClose() {
            //关闭界面时恢复用户之前选择的数据
            this.taskSchduleShow = false;
            if (this.oldSchedules.type) {
                if (this.oldSchedules.type == 'Once') {
                    this.activeName = 'first';
                    this.keepTabDailyData();
                    this.$refs.daily.dailyDisableFlage = true;
                    this.$refs.daily.onceDisableFlage = false;
                    this.$refs.daily.checkArr = [0];
                    if (this.oldSchedules.date) {
                        this.$refs.daily.$refs.onceDate.yearValue = this.oldSchedules.date.split("-")[0];
                        this.$refs.daily.$refs.onceDate.monthValue = this.oldSchedules.date.split("-")[1]
                        this.$refs.daily.$refs.onceDate.dayValue = this.oldSchedules.date.split("-")[2];
                    }
                    if (this.oldSchedules.times[0]) {
                        let time = this.oldSchedules.times[0];
                        this.$refs.daily.$refs.onceTime.hourValue = time.split(':')[0];
                        this.$refs.daily.$refs.onceTime.minuteValue = time.split(':')[1];
                    }
                }
                if (this.oldSchedules.type == 'Daily') {
                    this.activeName = 'first';
                    this.keepTabDailyData();
                    this.$refs.daily.onceDisableFlage = true;
                    this.$refs.daily.dailyDisableFlage = false;
                    this.$refs.daily.checkArr = [1];
                    this.$refs.daily.dailyTimeArr = this.oldDailyTimeArr;
                    let time;
                    if (this.oldSchedules.times.length) {
                        for (let i = 0; i < this.oldSchedules.times.length; i++) {
                            time = this.oldSchedules.times[i].split(":");
                            if (i == 0) {
                                this.$refs.daily.$refs.dailyTime0.hourValue = time[0];
                                this.$refs.daily.$refs.dailyTime0.minuteValue = time[1];
                            }
                            if (i == 1) {
                                this.$refs.daily.$refs.dailyTime1.hourValue = time[0];
                                this.$refs.daily.$refs.dailyTime1.minuteValue = time[1];
                            }
                            if (i == 2) {
                                this.$refs.daily.$refs.dailyTime2.hourValue = time[0];
                                this.$refs.daily.$refs.dailyTime2.minuteValue = time[1];
                            }
                        }
                    }
                }
                if (this.oldSchedules.type == 'Weekly') {
                    this.activeName = 'second';
                    this.$refs.daily.onceDisableFlage = true;
                    this.$refs.daily.dailyDisableFlage = true;
                    this.keepTabWeeklyData();
                    this.$refs.weekly.weekArr = Object.assign([], this.oldSchedules.weeks);
                    let time = this.oldSchedules.times[0].split(":");
                    this.$refs.weekly.$refs.weekTime.hourValue = time[0];
                    this.$refs.weekly.$refs.weekTime.minuteValue = time[1];
                }
                if (this.oldSchedules.type == 'Monthly') {
                    this.activeName = 'third';
                    this.$refs.daily.onceDisableFlage = true;
                    this.$refs.daily.dailyDisableFlage = true;
                    this.keepTabMonthlyData();
                    this.$refs.monthly.monthArr = Object.assign([], this.oldSchedules.days);
                    let time = this.oldSchedules.times[0].split(":");
                    this.$refs.monthly.$refs.monthTime.hourValue = time[0];
                    this.$refs.monthly.$refs.monthTime.minuteValue = time[1];
                }
            }
        },
        keepTabDailyData() {
            this.$refs.weekly.weekArr = [];
            this.$refs.monthly.monthArr = [];
        },
        keepTabWeeklyData() {
            this.$refs.daily.checkArr = [];
            this.$refs.daily.dailyTimeArr = [];
            this.$refs.daily.dailyDisableFlage = true;
            this.$refs.daily.onceDisableFlage = true;
            this.$refs.monthly.monthArr = [];
        },
        keepTabMonthlyData() {
            this.$refs.daily.checkArr = [];
            this.$refs.daily.dailyTimeArr = [];
            this.$refs.daily.dailyDisableFlage = true;
            this.$refs.daily.onceDisableFlage = true;
            this.$refs.weekly.weekArr = [];
        },
        clearAllData() {
            this.activeName = 'first';
            this.schedules.type = 'Once';
            this.$refs.daily.checkArr = [0];
            this.$refs.daily.dailyTimeArr = [];
            this.$refs.daily.dailyDisableFlage = true;
            this.$refs.daily.onceDisableFlage = true;
            this.$refs.weekly.weekArr = [];
            this.$refs.monthly.monthArr = [];
            this.days = [];
            this.weeks = [];
            this.$refs.daily.onceTime = '';
            let m = new Date().getMinutes();
            if (m < 10) {
                m = '0' + m;
            }
            this.$refs.daily.$refs.onceDate.yearValue = new Date().getFullYear();
            this.$refs.daily.$refs.onceDate.monthValue = new Date().getMonth() + 1;
            this.$refs.daily.$refs.onceDate.dayValue = new Date().getDate();
            this.$refs.daily.$refs.onceTime.hourValue = new Date().getHours();
            this.$refs.daily.$refs.onceTime.minuteValue = m;
            this.$refs.weekly.$refs.weekTime.hourValue = new Date().getHours();
            this.$refs.weekly.$refs.weekTime.minuteValue = m;
            this.$refs.monthly.$refs.monthTime.hourValue = new Date().getHours();
            this.$refs.monthly.$refs.monthTime.minuteValue = m;
            this.$refs.daily.$refs.dailyTime0.hourValue = new Date().getHours();
            this.$refs.daily.$refs.dailyTime0.minuteValue = m;
            this.$refs.daily.$refs.dailyTime1.hourValue = new Date().getHours();
            this.$refs.daily.$refs.dailyTime1.minuteValue = m;
            this.$refs.daily.$refs.dailyTime2.hourValue = new Date().getHours();
            this.$refs.daily.$refs.dailyTime2.minuteValue = m;
        }
    },
}
</script>

<style>
#taskSchdule #tab-first,
#taskSchdule #tab-second,
#taskSchdule #tab-third {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/

}

#taskSchdule {
    width: 680px;
    /*no*/
    height: 440px;
    /*no*/
}

.task-schdule-body {
    width: 100%;
    height: 400px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 20px 20px;
    /*no*/
}

.schedule-bar-one {
    width: 55px !important;
    /*no*/
    transform: translateX(0px);
    /*no*/
}

.schedule-bar-two {
    width: 55px !important;
    /*no*/
    transform: translateX(77px);
    /*no*/
}

.schedule-bar-three {
    width: 55px !important;
    /*no*/
    transform: translateX(163px);
    /*no*/
}

.schedule-content {
    width: 100%;
    height: 300px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
    position: relative;
    margin: auto;
}

#taskSchdule .el-tabs__content {
    height: 300px;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/task_schedule_popup.vue